module.exports = __webpack_public_path__ + "img/gallery16.96af77d5.jpg";